export default __webpack_public_path__ + "static/media/load-unselected.69b0bfda.png";